import styled from 'styled-components';

export default styled.div`
    background-size: cover;
    background-color: var(--color-body-bg);
    min-height: 100vh;
    min-height: 100dvh;
    height: 100dvh;
`;
